import { CreateButton, ExportButton, TopToolbar } from 'react-admin';

export const DiseasesListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);
